import React, { useEffect, useState, ChangeEvent, FocusEvent } from "react";
import { useParams } from "react-router-dom";
import CardLoader from "../loader/CardLoader";
import { toast } from 'react-toastify';
import { phonesNumberCountries } from "../config/constant";
import { handleChangeStringField } from "../functions/reactFieldChange";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { ISuppPalmares, ISuppPalmaresFields, ISuppPalmaresProps, ISuppPalmaresData, IQuestionnaireProps,IQuestionTransitionEcologique, ISuppSetting } from "../type/type";
import { Form } from "react-bootstrap";
import { useQuery, useMutation, useQueryClient } from "react-query";
import config from "../config/config";
import axios from "axios";
import { DateTime } from 'luxon';
import { NumericFormat } from 'react-number-format';

const Palmares = () => 
{
    const logo = require("../assets/img/logo.png")
    const checkIcon = require("../assets/img/check.jpg")
    const tropheeIcon = require("../assets/img/trophee.jpg")
    const graphiqueIcon = require("../assets/img/graphique.jpg")
    const questionIcon = require("../assets/img/question.jpg")
    const footerImage = require("../assets/img/footer.jpg")
    const [updateSucceed, setUpdateSucceed] = useState<boolean>(false)
    const { id } = useParams()
    const [ loading, setLoading ] = useState<boolean>(true)
    const [ questionnaire, setQuestionnaire ] = useState<string[]>([])
    const queryClient = useQueryClient()
    const {data: palmares } = useQuery<ISuppPalmares>
    (
        "palmares"
        ,async () => 
        {
            return await axios.get(`${config.backUrl}`, 
            {
                params : 
                {
                    controller: "palmares",
                    id : id
                }
            }).then(response => 
            {
                setLoading(false)
                return response.data
            })
            .catch((error) => 
            {
                setLoading(false)
                if (error.response) 
                {
                    console.error(error.response.data.detail)
                } else if (error.request) 
                {
                    console.error(error.request)
                } else {
                    console.error(error.message)
                }
            })
        },
        {
            enabled : loading
        }
    )
    const {data: questionsData } = useQuery<IQuestionTransitionEcologique[]>(
    'questionsData'
    ,async () => 
    {
        return await axios.get(`${config.backUrl}`,
        {
            params : 
            {
                controller: "palmaresQuestionnaire",
            }
        }).then(response => 
        {
            const extractResponses = (questions: IQuestionTransitionEcologique[]): string[] => {
                const responses: string[] = [];
                const traverseQuestions = (questions: IQuestionTransitionEcologique[]) => {
                    questions.forEach((question) => {
                        question.reponses?.forEach((reponse) => {
                            if ((palmares?.transitionEcologiques?.map((item) => item.reponseId) ?? []).includes(reponse.id)) {
                                responses.push(`${question.id}-${reponse.id}`);
                            }
                        });
                        if (question.questions && question.questions.length > 0) {
                            traverseQuestions(question.questions);
                        }
                    });
                };
                traverseQuestions(questions);
                return responses;
            };
            const allResponses = extractResponses(response.data);
            setQuestionnaire(allResponses);
            return response.data
        })
    },
    {
        enabled : questionnaire.length === 0 && palmares !== undefined
    })
    const {data: settings } = useQuery<ISuppSetting[]>
    (
        "settings"
        ,async () => 
        {
            return await axios.get(`${config.backUrl}`, 
            {
                params : { controller: "palmaresSetting" }
            }).then(response => 
            {
                setLoading(false)
                return response.data
            })
            .catch((error) => 
            {
                setLoading(false)
                if (error.response) 
                {
                    console.error(error.response.data.detail)
                } else if (error.request) 
                {
                    console.error(error.request)
                } else {
                    console.error(error.message)
                }
            })
        },
        {
            enabled : loading
        }
    )
    const questions: IQuestionTransitionEcologique[] = questionsData ?? []

    const [errorForm, setErrorForm] = useState({
        raisonSociale: {
            hadSelected: false,
            message: ""
        },
        nom: {
            hadSelected: false,
            message: ""
        },
        caN2: {
            hadSelected: false,
            message: ""
        },
        caN1: {
            hadSelected: false,
            message: ""
        },
        resultatN1: {
            hadSelected: false,
            message: ""
        },
        effectif: {
            hadSelected: false,
            message: ""
        }
    })
    const [fields, setFields] = useState<ISuppPalmaresFields>({
        raisonSociale: ""
        ,nom: ""
        ,caN2: 0
        ,caN1: 0
        ,resultatN1: 0
        ,effectif: 0
        ,telephone: ""
        ,adresse: ""
        ,adresseComplement : ""
        ,codePostal: ""
        ,ville: ""
        ,transitionEcologiques: []
        ,noTransitionEcologique: false
    })
    useEffect(() => 
    {
        setErrorForm(
        {
            raisonSociale: {
                hadSelected: fields.raisonSociale !== "" ? true : false,
                message: ""
            },
            nom: {
                hadSelected: fields.nom !== "" ? true : false,
                message: ""
            },
            caN2: {
                hadSelected: fields.caN2 > 0 ? true : false,
                message: (fields.caN2 > 0) ? "" : "Cette valeur doit être supérieure à 0"
            },
            caN1: {
                hadSelected: fields.caN1 > 0 ? true : false,
                message: (fields.caN1 > 0) ? "" : "Cette valeur doit être supérieure à 0"
            },
            resultatN1: {
                hadSelected: fields.resultatN1 > 0 ? true : false,
                message: (fields.resultatN1 > 0) ? "" : "Cette valeur doit être supérieure à 0"
            },
            effectif: {
                hadSelected: fields.effectif !== null ? true : false,
                message: ""
            }
        })
    }, [fields])
    const handleCheckError = ({ currentTarget }: ChangeEvent<HTMLInputElement> | FocusEvent<any>) => 
    {
        if (currentTarget.required && currentTarget.value === "")
        {
            setErrorForm({ ...errorForm, [currentTarget.name] : {
                message:`Ce champ est obligatoire`,
                hadSelected: true 
            }})
        }else {
            if((currentTarget.name === "caN1" || currentTarget.name === "caN2" || currentTarget.name === "resultatN1") && parseInt(currentTarget.value) <= 0)
            {
                setErrorForm({ ...errorForm, [currentTarget.name]: {
                    message: `Cette valeur doit être supérieure à 0`,
                    hadSelected: true 
                }});
            }else
            {
                setErrorForm({ ...errorForm, [currentTarget.name]: {
                    message: "",
                    hadSelected: true 
                }});
            }
        }
    }
    const mutationPalmares = useMutation(
        async ({fields, id} : ISuppPalmaresProps) => 
        {
            let customerFields = {
                ...fields,
                transitionEcologiques: fields.noTransitionEcologique ? [] : questionnaire?.map((item) => item.split("-")[1]) 
            }
            let data = {
                ...customerFields,
                id: id,
                controller: "palmares",
                action: "patch"
            } as ISuppPalmaresData;
            return axios.post(config.backUrl, data, {
                headers : {
                    "Content-Type" : "application/x-www-form-urlencoded"
                }
            })
        },
    )
    const handleSaveData = (id : number) => 
    {
        let hasError = false
        let errorMessage = [];
        for (const [key, value] of Object.entries(errorForm)) 
        {
            if (value.message !== "" || !value.hadSelected) 
            {
                hasError = true
                const label = key === "raisonSociale" ? "Raison sociale" :
                                key === "nom" ? "Dirigeant" :
                                key === "caN2" ? "CA N-2" :
                                key === "caN1" ? "CA N-1" :
                                key === "resultatN1" ? "Résultat N-1" :
                                key === "effectif" ? "Effectif" : key;

                errorMessage.push(`${label} : ${value.message}`);
            }
        }
        let hasErrorQuestion = false
        const collectQuestionIds = (questions: IQuestionTransitionEcologique[]): number[] => 
        {
            const ids: number[] = [];
            const traverseQuestions = (questions: IQuestionTransitionEcologique[]) => 
            {
                questions.forEach((question) => 
                {
                    ids.push(question.id);
                    if (question.questions && question.questions.length > 0) {
                        traverseQuestions(question.questions);
                    }
                });
            };
            traverseQuestions(questions);
            return ids;
        };
        const questionIds = collectQuestionIds(questions);
        questionIds.forEach((questionId) => {
            if (!questionnaire.some((response) => response.startsWith(`${questionId}-`))) 
            {
                hasErrorQuestion = true;
            }
        });
        if(hasErrorQuestion && !fields.noTransitionEcologique)
        {
            hasError = true
            errorMessage.push("Vérifier le questionnaire, veuillez donner au moins une réponse pour chaque question");
        }
        if(!hasError)
        {
            const toastPalmares = toast.loading("Enregistrement en cours ...",
            {
                type: "success",
                position: "bottom-left",
                draggable: false,
                progress: 0,
                theme: "light",
                className: "fs-5"
            })
            mutationPalmares.mutateAsync({fields : fields, id: id} , 
            {
                onSuccess: () => 
                {
                    toast.update(toastPalmares, 
                    {
                        isLoading: false,
                        hideProgressBar: true,
                        render: "Enregistrement effectué avec succès !"
                    })
                    setUpdateSucceed(true)
                    setTimeout(() => { toast.dismiss(toastPalmares) }, 5000)
                },
                onError: (error: any) => 
                {
                    let errorMessage;
                    if (error.response && error.response.data && error.response.data.errors) 
                    {
                        const errors = error.response.data.errors;
                        const flatObject = Object.keys(errors).reduce((result: { [key: string]: string }, key) => {
                            const formattedKey = key.charAt(0).toLowerCase() + key.slice(1); // Première lettre en minuscule
                            result[formattedKey] = errors[key][0]; // Prendre le premier message d'erreur pour chaque champ
                            return result;
                        }, {});
                        errorMessage = Object.values(flatObject).join("<br />");
                    }else if(error.response && error.response.data && error.response.data.error)
                    {
                        errorMessage = error.response.data.error;
                    } else {
                        errorMessage = error.message;
                    }

                    toast.update(toastPalmares, 
                    {
                        isLoading: false,
                        hideProgressBar: true,
                        type: "error",
                        render: <div dangerouslySetInnerHTML={{ __html: `Erreur lors de l'enregistrement : <br /> ${errorMessage}<br /> veuillez contacter l'administrateur SVP!` }} />
                    })
                    setTimeout(() => { toast.dismiss(toastPalmares) }, 5000);
                }
            })
        }else
        {
            toast.error(<div dangerouslySetInnerHTML={{__html: errorMessage.join("<br/>")}}></div>);
        }
    }
    const handleChangeQuestion = (e: React.ChangeEvent<HTMLInputElement>) => 
    {
        const value = e.target.value;
        if (e.target.checked) 
        {
            if (e.target.type === "checkbox") 
            {
                setQuestionnaire((prev) => [...prev, value]);
            } else {
                const questionId = value.split("-")[0];
                setQuestionnaire((prev) => {
                    const newQuestionnaire = prev.filter(
                        (item) => !item.startsWith(`${questionId}-`)
                    );
                    return [...newQuestionnaire, value];
                })
            }
        } else {
            setQuestionnaire((prev) => prev.filter((item) => item !== value));
        }
    }
    const Question = ({ question } : IQuestionnaireProps) => 
    {
        return (
            <>
                <span className={`mb-1${question.parentId === null ? ' fw-semibold' : ' fw-normal'}`}>{question.label}</span>
                <div className="row mb-2 fw-normal fs-6">
                    <div className="col-12">
                        <span className="ms-2 my-2 d-block">{`Réponse${question.multiple ? "s" : ""} (${question.multiple ? "plusieurs choix" : "une seule"} possible${question.multiple ? "s" : ""}) :`}</span>
                        {question.reponses?.map((reponse) => 
                        (
                            <div className="row">
                                <div className="col-12">
                                    <Form.Check
                                        type={question.multiple ? "checkbox" : "radio"}
                                        label={reponse.label}
                                        name={`question-${question.id}`}
                                        id={`question-${question.id}-${reponse.id}`}
                                        value={`${question.id}-${reponse.id}`}
                                        onChange={handleChangeQuestion}
                                        checked={(questionnaire.map(q => parseInt(q.split("-")[1])) ?? []).includes(reponse.id)}
                                        className="me-2"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    {question.help && (
                        <div className="my-2 text-sm text-gray-500 fst-italic text-muted ms-4">* {question.help}</div>
                    )}
                </div>
                {question.questions !== undefined && question.questions?.length > 0 && (
                    <div className="my-2 fw-normal fs-6">
                        {question.questions.map((child) => (
                            <Question key={child.id} question={child} />
                        ))}
                    </div>
                )}
            </>
        );
    }
    useEffect(() => 
    {
        setFields({
            raisonSociale: palmares?.raisonSociale ?? ""
            ,nom: palmares?.nom ?? ""
            ,caN2: palmares?.caN2 ?? 0
            ,caN1: palmares?.caN1 ?? 0
            ,resultatN1: palmares?.resultatN1 ?? 0
            ,effectif: palmares?.effectif ?? 0
            ,telephone: palmares?.telephone ?? ""
            ,adresse: palmares?.adresse ?? ""
            ,adresseComplement: palmares?.adresseComplement ?? ""
            ,codePostal: palmares?.codePostal ?? ""
            ,ville: palmares?.ville ?? ""
            ,transitionEcologiques: palmares?.transitionEcologiques?.map((item) => item.reponseId) ?? []
            ,noTransitionEcologique: palmares?.noTransitionEcologique ?? false
        })
        
    }, [ palmares])

    
    return (
        <div className='container-fluid'>
              {updateSucceed
                ? (
                    <div className="row justify-content-center">
                        <div className="card mt-4 shadow col-12 col-sm-10 col-md-8 col-lg-6">
                            <div className="row justify-content-center">
                                <div className="col-8 col-sm-5 col-md-4 d-flex flex-column align-items-center gap-2 mt-4">
                                    <img src={logo} alt="Tribune Bulletin Côte d'Azur" title="Palmares Bulletin Côte d'Azur" className="img-fluid" />
                                    <img src={checkIcon} alt="Merci !" title="Merci !" className="img-fluid" />
                                </div>
                            </div>
                            <div className="row justify-content-center align-items-center">
                                <div className="col-12 col-md-10 my-4 text-center">
                                    <h1 className="fs-2 fs-sm-1 fw-bold">Merci !</h1>
                                    <span className="fs-5 fs-sm-4 fw-bold" style={{color:"#0ea836"}}>Vos données ont bien été enregistrées</span>
                                    <span style={{border:"solid 2px #0ea836"}} className="d-block w-25 mx-auto my-3"></span>
                                    <p className="text-center">
                                        Votre participation nous aide à dresser un panorama précis
                                        des entreprises engagées sur notre territoire.
                                    </p>
                                    <p className="text-center">
                                        Les résultats du baromètre et le <span className="fw-bold" style={{color:"#0ea836"}}>Palmarès {DateTime.now().year}&nbsp;
                                        des 500 premières entreprises de la Côte d'Azur</span> seront publiés dans notre Hors série.<br />
                                        Vous serez informé de la sortie prochaine.
                                    </p>
                                    <ul className="list-group">
                                        <li className="list-group-item text-start d-flex flex-column flex-sm-row gap-3 border-bottom-0">
                                            <img src={tropheeIcon} alt={`Palmarès ${DateTime.now().year}`} title={`Palmarès ${DateTime.now().year}`} className="img-fluid align-self-start align-self-sm-center" style={{maxWidth:"3rem"}} />
                                            <div className="d-flex flex-column">
                                                <span className="fs-5 fw-bold">Palmarès {DateTime.now().year} </span>
                                                <p>
                                                    Découvrez prochainement le classement exclusif des 500 premières
                                                    entreprises de la Côte d'Azur
                                                </p>
                                                <span className="d-block border border-1 w-100"></span>
                                            </div>
                                        </li>
                                        <li className="list-group-item text-start d-flex flex-column flex-sm-row gap-3 border-bottom-0 border-top-0">
                                            <img src={graphiqueIcon} alt={`Palmarès ${DateTime.now().year}`} title={`Palmarès ${DateTime.now().year}`} className="img-fluid align-self-start align-self-sm-center" style={{maxWidth:"3rem"}} />
                                            <div className="d-flex flex-column">
                                                <span className="fs-5 fw-bold">Un baromètre pour agir</span>
                                                <p>
                                                    Vos réponses contribuent à mieux comprendre les enjeux économiques,
                                                    sociaux et environnementaux de notre région.
                                                </p>
                                                <span className="d-block border border-1 w-100"></span>
                                            </div>
                                        </li>
                                        <li className="list-group-item text-start d-flex flex-column flex-sm-row gap-3 border-top-0">
                                            <img src={questionIcon} alt={`Palmarès ${DateTime.now().year}`} title={`Palmarès ${DateTime.now().year}`} className="img-fluid align-self-start align-self-sm-center" style={{maxWidth:"3rem"}} />
                                            <div className="d-flex flex-column">
                                                <span className="fs-5 fw-bold">Une question ?</span>
                                                <p className="mb-1">
                                                    Notre équipe reste à votre disposition:
                                                </p>
                                                <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-1 gap-sm-2">
                                                    <a href="mailto:contact@tribuca.net" title="Nous envoyer un email à contact@tribuca.net">contact@tribuca.net</a>
                                                    <span className="d-none d-sm-inline">|</span>
                                                    <a href="tel:0492175500" title="Nous appeler au numéro 04 92 17 55 00">04 92 17 55 00</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <img src={footerImage} alt="Merci pour votre engagement !" title="Merci pour votre engagement !" className="img-fluid mt-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                  )
                : (
                    <>
                        <div className="row d-flex justify-content-center">
                            <div className="col-3">
                                <header className='d-flex justify-content-center my-4'>
                                    <img src={logo} alt="Tribune Bulletin Côte d'Azur" title="Palmares Bulletin Côte d'Azur" className="img-fluid" />
                                </header>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center">
                            <div className='col-lg-8 col-12'>
                                {loading
                                    ?
                                        (<div className="card mt-4 shadow">
                                            <div className="card-body">
                                                <CardLoader />
                                            </div>
                                        </div>)
                                    :
                                    (
                                        <div className="card mt-4 shadow">
                                            <div className="card-header fw-bold fs-4">
                                                Mise à jour des données 
                                                {palmares?.id
                                                    &&
                                                    (
                                                        <h4 className="card-subtitle fw-normal fs-5 my-1 text-muted">{palmares.raisonSociale} </h4>
                                                    )
                                                }
                                            </div>
                                            <div className="card-body py-4">
                                                {(palmares !== undefined && palmares.id !== undefined)
                                                    ?
                                                    (
                                                        <>
                                                            <div className="row my-3">
                                                                <div className="col-md-6 col-12">
                                                                    <label htmlFor="raisonSociale" className="form-label">Raison sociale</label>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        name="raisonSociale"
                                                                        onBlur={handleCheckError}
                                                                        value={fields.raisonSociale} 
                                                                        required={true}
                                                                        onChange={(e) => {
                                                                            handleChangeStringField(e, fields, setFields)
                                                                        }}
                                                                    />
                                                                    {errorForm.raisonSociale.message !== "" &&
                                                                        <div className="text-danger errorMessage">{errorForm.raisonSociale.message}</div>
                                                                    }
                                                                </div>
                                                                <div className="col-md-6 col-12">
                                                                    <label htmlFor="nom" className="form-label">Dirigeant(s)</label>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        name="nom"
                                                                        onBlur={handleCheckError}
                                                                        value={fields.nom} 
                                                                        required={true}
                                                                        onChange={(e) => {
                                                                        handleChangeStringField(e, fields, setFields)
                                                                    }}
                                                                />
                                                                {errorForm.nom.message !== "" &&
                                                                    <div className="text-danger errorMessage">{errorForm.nom.message}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col-md-6 col-12">
                                                                <label htmlFor="caN2" className="form-label">
                                                                    CA 
                                                                    <span className="badge bg-info ms-1">
                                                                        {(palmares.annualUpdate !== undefined && palmares.createdAt !== undefined
                                                                            && (DateTime.fromISO(palmares.createdAt) < DateTime.fromISO(palmares.annualUpdate)))
                                                                            ?
                                                                            (
                                                                                <>{DateTime.fromISO(palmares.annualUpdate).minus({ year : 2}).toFormat("yyyy")}</>
                                                                            )
                                                                            :
                                                                            (
                                                                                <>{DateTime.now().minus({year: 2}).toFormat("yyyy")}</>
                                                                            )
                                                                        }
                                                                    </span>
                                                                </label>
                                                                <NumericFormat 
                                                                    thousandSeparator={" "}
                                                                    allowLeadingZeros 
                                                                    className="form-control" 
                                                                    name="caN2"
                                                                    id="caN2"
                                                                    required={true}
                                                                    value={fields.caN2}
                                                                    onBlur={handleCheckError}
                                                                    onValueChange={(values) => 
                                                                    {
                                                                        setFields({ ...fields, "caN2": parseInt(values.value)})
                                                                    }}
                                                                />
                                                                {errorForm.caN2.message !== "" &&
                                                                    <div className="text-danger errorMessage">{errorForm.caN2.message}</div>
                                                                }
                                                            </div>
                                                            <div className="col-md-6 col-12">
                                                                <label htmlFor="caN1" className="form-label">
                                                                    CA
                                                                    <span className="badge bg-info ms-1">
                                                                        {(palmares.annualUpdate !== undefined && palmares.createdAt !== undefined
                                                                            && (DateTime.fromISO(palmares.createdAt) < DateTime.fromISO(palmares.annualUpdate)))
                                                                            ?
                                                                            (
                                                                                <>{DateTime.fromISO(palmares.annualUpdate).minus({ year : 1}).toFormat("yyyy")}</>
                                                                            )
                                                                            :
                                                                            (
                                                                                <>{DateTime.now().minus({year: 1}).toFormat("yyyy")}</>
                                                                            )
                                                                        }
                                                                    </span>
                                                                </label>
                                                                <NumericFormat 
                                                                    thousandSeparator={" "}
                                                                    allowLeadingZeros 
                                                                    className="form-control" 
                                                                    name="caN1"
                                                                    id="caN1"
                                                                    required={true}
                                                                    value={fields.caN1}
                                                                    onBlur={handleCheckError}
                                                                    onValueChange={(values) => 
                                                                    {
                                                                        if(parseInt(values.value) < 0)
                                                                        {
                                                                            setErrorForm({
                                                                                ...errorForm, caN1: {
                                                                                    message: "Le CA N-1 ne peut pas être négatif",
                                                                                    hadSelected: true
                                                                                }
                                                                            })
                                                                        }
                                                                        setFields({ ...fields, "caN1": parseInt(values.value)})
                                                                    }}
                                                                />
                                                                {errorForm.caN1.message !== "" &&
                                                                    <div className="text-danger errorMessage">{errorForm.caN1.message}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col-md-6 col-12">
                                                                <label htmlFor="resultatN1" className="form-label">
                                                                    Résultat 
                                                                    <span className="badge bg-info ms-1">
                                                                        {(palmares.annualUpdate !== undefined && palmares.createdAt !== undefined
                                                                            && (DateTime.fromISO(palmares.createdAt) < DateTime.fromISO(palmares.annualUpdate)))
                                                                            ?
                                                                            (
                                                                                <>{DateTime.fromISO(palmares.annualUpdate).minus({ year : 1}).toFormat("yyyy")}</>
                                                                            )
                                                                            :
                                                                            (
                                                                                <>{DateTime.now().minus({year: 1}).toFormat("yyyy")}</>
                                                                            )
                                                                        }
                                                                    </span>
                                                                </label>
                                                                <NumericFormat 
                                                                    thousandSeparator={" "}
                                                                    allowLeadingZeros 
                                                                    className="form-control" 
                                                                    name="resultatN1"
                                                                    id="resultatN1"
                                                                    required={true}
                                                                    value={fields.resultatN1}
                                                                    onBlur={handleCheckError}
                                                                    onValueChange={(values) => 
                                                                    {
                                                                        if(parseInt(values.value) < 0)
                                                                        {
                                                                            setErrorForm({
                                                                                ...errorForm, resultatN1: {
                                                                                    message: "Le resultat N-1 ne peut pas être négatif",
                                                                                    hadSelected: true
                                                                                }
                                                                            })
                                                                        }
                                                                        setFields({ ...fields, "resultatN1": parseInt(values.value)})
                                                                    }}
                                                                />
                                                                {errorForm.resultatN1.message !== "" &&
                                                                    <div className="text-danger errorMessage">{errorForm.resultatN1.message}</div>
                                                                }
                                                            </div>
                                                            <div className="col-md-6 col-12">
                                                                <label htmlFor="effectif" className="form-label">
                                                                    Effectif(s)
                                                                </label>
                                                                <input type="number" 
                                                                    className="form-control" 
                                                                    name="effectif"
                                                                    onBlur={handleCheckError}
                                                                    value={fields.effectif} 
                                                                    required={true}
                                                                    onChange={(e) => {
                                                                        handleChangeStringField(e, fields, setFields)
                                                                    }}
                                                                />
                                                                {errorForm.effectif.message !== "" &&
                                                                    <div className="text-danger errorMessage">{errorForm.effectif.message}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col-md-6 col-12">
                                                                <label htmlFor="tel" className="form-label">Téléphone</label>
                                                                <PhoneInput
                                                                    name='telephone'
                                                                    value={fields.telephone}
                                                                    required={false}
                                                                    onChange={(value) =>{ 
                                                                        setFields({ ...fields, telephone: value ?? ""})
                                                                    }}
                                                                    displayInitialValueAsLocalNumber
                                                                    defaultCountry="FR"
                                                                    autoComplete={'new-' + fields.telephone}
                                                                    countries={phonesNumberCountries}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="mb-3 col-md-4 xs:d-none d-inline"></div>
                                                                    <h3 className="text-2xl font-bold mb-6 col-md-4 col-12 text-center d-flex justify-content-center align-items-center">
                                                                        Baromètre RSE
                                                                    </h3>
                                                                     {(settings !== undefined && settings.filter((setting: ISuppSetting) => setting.nom === "logo_rse")[0] !== undefined
                                                                        && settings.filter((setting: ISuppSetting) => setting.nom === "logo_rse")[0].valeur !== "")
                                                                    &&
                                                                    (
                                                                        <div className="col-md-4 col-12 d-flex justify-content-end">
                                                                            <img src={settings.filter((setting: ISuppSetting) => setting.nom === "logo_rse")[0].valeur} className="logoImpactFrance" alt="Impact France" />
                                                                        </div>
                                                                    )}
                                                                    
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                {(settings !== undefined && settings.filter((setting: ISuppSetting) => setting.nom === "pdf_rse_content")[0] !== undefined)
                                                                &&
                                                                (
                                                                    <div dangerouslySetInnerHTML={{ __html: settings.filter((setting: ISuppSetting) => setting.nom === "pdf_rse_content")[0].valeur }} />
                                                                )}
                                                                <div className="row my-2">
                                                                    <div className="col-12">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Ne souhaite pas répondre au questionnaire"
                                                                            id="noTransitionEcologique"
                                                                            name="noTransitionEcologique"
                                                                            onChange={(e) => 
                                                                            {
                                                                                setFields({ ...fields, noTransitionEcologique: e.currentTarget.checked})
                                                                                if(!e.currentTarget.checked)
                                                                                {
                                                                                    queryClient.invalidateQueries(['questionsData']);
                                                                                }
                                                                            }}
                                                                            checked={fields.noTransitionEcologique}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <ol type="I" className={`list-group list-group-numbered ${fields.noTransitionEcologique ? 'd-none' : 'd-block'}` }>
                                                                    {questions.map((question) => (
                                                                        <li className="list-group-item fs-5 border-0" key={question.id}>
                                                                            <Question key={question.id} question={question} />
                                                                        </li>
                                                                    ))}
                                                                </ol>
                                                            </div>
                                                        </div>
                                                        <div className="row my-3 d-flex justify-content-center">
                                                            <div className="col-md-5 col-10 d-flex justify-content-end">
                                                                <button type="button" className="text-uppercase btn btn-primary" onClick={() => handleSaveData(palmares.id) }>
                                                                    Enregistrer (Même sans changement)
                                                                </button>
                                                            </div> 
                                                        </div>
                                                    </>
                                                )
                                                :
                                                (
                                                    <div className="alert alert-danger" role="alert">
                                                        Impossible de charger les données, veuillez contacter l'administrateur du site
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </>
              )}
              <div className="row d-flex justify-content-center">
                  <div className="col-10">
                      <footer className='d-flex justify-content-center my-4 text-muted'>
                        &copy; Tribune Côte d'Azur
                      </footer>
                  </div>
              </div>
          </div>
    )
}

export default Palmares;